import { RedCards } from 'components/RedCards/RedCards';
import { MatchOffer } from 'types/MatchOffer';
import styles from './SearchResultEvent.module.css';
import { LiveEvent } from 'types/LiveEvent';
import { formatDateTime } from 'helpers/dateHelper';
import { useNavigate } from 'react-router-dom';

interface Props {
  event: MatchOffer | LiveEvent;
  liveEvent?: boolean;
}

export const SearchResultEvent = ({ event, liveEvent = false }: Props) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    let destination = `/sports-betting/match/${event.fi}`;

    if (liveEvent) {
      destination = '/live-betting';
    }
    navigate(destination);
  };

  return (
    <div
      className={styles.matchWrapper}
      key={event.fi}
      onClick={handleNavigate}
    >
      <div className={styles.time}>
        {event.time && liveEvent
          ? event.time
          : formatDateTime(new Date(Number.parseInt(event.time + '') * 1000), {
              removeSeconds: true,
              removeYear: true,
            })}
      </div>
      <div className={styles.teams}>
        <div>
          {event.home?.name ?? (event as MatchOffer).league?.name ?? 'Unknown'}
          {liveEvent && (
            <RedCards
              count={(event as LiveEvent).homeRedCards}
              yellow={(event as LiveEvent).liveCounts?.yellow?.[0]}
            />
          )}
        </div>
        <div>
          {event.away?.name ?? '-'}
          {liveEvent && (
            <RedCards
              count={(event as LiveEvent).awayRedCards}
              yellow={(event as LiveEvent).liveCounts?.yellow?.[1]}
            />
          )}
        </div>
      </div>
      <div className={styles.rightSide}>
        {liveEvent && (
          <div className={styles.result}>
            {(event as LiveEvent).homeGoals}:{(event as LiveEvent).awayGoals}
          </div>
        )}
        <div className={styles.chevronRight} />
      </div>
    </div>
  );
};
